export default function Footer(){
    return (
      <footer >
        {/* style={{flex: "0 1 0"}} */}
        <div class="container">
          <div class="row">
            <div class="col-lg-6 col-12 dont-print">
              <ul class="footer__links-list" role="list">
                <li class="footer__links-listitem" role="listitem">
                  <a href="https://beta.southglos.gov.uk/website-accessibility-statement" title="Accessibility">Accessibility</a>
                </li>
                <li class="footer__links-listitem" role="listitem">
                  <a href="https://www.southglos.gov.uk/contact" title="Contact">Contact</a>
                </li>
                <li class="footer__links-listitem" role="listitem">
                  <a href="https://www.southglos.gov.uk/privacy" title="Privacy">Privacy</a>
                </li>
                <li class="footer__links-listitem" role="listitem">
                  <a href="https://beta.southglos.gov.uk/translate/" title="Translate">Translate</a>
                </li>
              </ul>
            </div>
            <div class="col-lg-6 col-12 text-end">
              <p id="copyright">© South Gloucestershire Council 2025</p>
            </div>
          </div>
        </div>
      </footer>
    );
}